import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RemovePuncPipe } from './remove-punc.pipe';

import { Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-forest-finder',
    templateUrl: './forest-finder.component.html',
    providers: [RemovePuncPipe],
    styleUrls: ['./forest-finder.scss'],
    standalone: false
})
export class ForestFinderComponent implements OnInit {
  @ViewChild('forestFinder') form: ElementRef;

  forests;
  selectedForest = {
    code: '',
    forestName: ''
  }
  selectedProduct = {
    friendly: '',
    type: ''
  }
  itemsPerRow = 2;
  showForestSelectError = false;
  products = []
  heroDots = [
    {
      image: ''
    }, {
      image: ''
    }, {
      image: ''
    }, {
      image: ''
    }, {
      image: ''
    }
  ]
  selectedDot = 0;
  screenWidth: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private meta: Meta
  ) {
    this.meta.addTag({
      name: 'description', content: 'Use Open Forest to purchase\
 a Firewood permit with the United States Forest Service.'
    });
  }

  /**
   * Set forest from route resolver
   */
  ngOnInit() {
    this.screenWidth = window.innerWidth;
    this.route.data.subscribe(data => {
      this.forests = data.forests;

      this.forests.forEach((forest) => {
        forest.friendly = forest.forestNameFormal
        forest.states.forEach((state) => {
          forest.friendly += ' (' + state + ')'
        })
      })

      // sort forests alphabetically
      this.forests.sort(function(a, b) {
        const forestA = a.description;
        const forestB = b.description;

        if (forestA < forestB) {
          return -1;
        }
        if (forestA > forestB) {
          return 1;
        }
        return 0;
      });
    });
    if (this.screenWidth > 1023) {
      // this.startHeroTimer();
    }
  }

  startHeroTimer() {
    setTimeout(() => {
      if (this.selectedDot === 4) {
        this.selectedDot = 0
      } else {
        this.selectedDot++;
      }
      this.selectDot(this.selectedDot);
      this.startHeroTimer();
    }, 5000)
  }

  /**
   * Set focus to form
   */
  scrollToForestFinder(event) {
    if (event) {
      event.preventDefault();
    }

    this.form.nativeElement.focus();

  }

  /**
   * Redirect to forest guidelines page
   */
  goToForest(forest) {
    this.router.navigate([`forests/${this.selectedForest.code}/products/${this.selectedProduct.type}`])
  }

  // change products dropdown options based on selected forest
  onForestChange = (e) => {
    this.products = e.permitTypes
  }

  selectDot = (index) => {
    this.selectedDot = index
  }

  selectForest = (forest) => {
    this.selectedForest = forest
    this.selectedProduct = {
      friendly: '',
      type: ''
    }
    this.products = forest.permitTypes
  }

  selectProduct = (product) => {
    this.selectedProduct = product
  }
}
